import { jsx as _jsx } from "react/jsx-runtime";
import { DoctorPatientProvider, DoctorPatients as DoctorPatientsUi, Spinner, } from "@madmedical/ui";
import { invariant } from "@madmedical/utils";
import useProvidePatients from "../useProvidePatients";
const DoctorPatients = () => {
    const { patients, pagination, handleSortChange, handleSearchChange, filterChoices, handleFilterChange, handleEndReached, isLoading, } = useProvidePatients();
    if (isLoading) {
        return _jsx(Spinner, {});
    }
    invariant(patients, "No patients in sight");
    invariant(pagination, "No patients in sight");
    return (_jsx(DoctorPatientProvider, Object.assign({ value: {
            patients,
            pagination,
            onSortChange: handleSortChange,
            onSearchChange: handleSearchChange,
            filterChoices,
            onFilterChange: handleFilterChange,
        } }, { children: _jsx(DoctorPatientsUi, { onEndReached: handleEndReached }) })));
};
export default DoctorPatients;
